var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"text-lg user-select-none opacity-25 absolute bottom-0 right-0 p-2 flex",attrs:{"href":"https://apenhet.org","target":"_blank"}},[_c('span',[_vm._v("åpen")]),_c('span',{staticClass:"font-bold"},[_vm._v("het")])])}]

export { render, staticRenderFns }